import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { BannerProvider } from "./contexts/BannerContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Offers from "./components/Offers";
import Portfolio from "./components/Portfolio";
import Team from "./components/Team";
import Testimonials from "./components/Testimonials";
import Blog from "./components/Blog";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import BlogPost from "./components/BlogPost";
import ContactUsPage from "./components/ContactUsPage";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import CookiePolicy from "./components/Cookiepolicy";
import { Analytics } from "@vercel/analytics/react"
import FloatingActionButton from "./components/FloatingActionButton";

// Main content component (Home page)
const MainContent = () => (
  <div className="min-h-screen">
    <Header />
    <Hero />
    <Services />
    <Offers />
    <Portfolio />
    <Team />
    <Testimonials />
    <Blog />
    <Contact />
    <Footer />
    <Toaster />
    <FloatingActionButton />
  </div>
);

// Blog page component
const BlogPage = () => (
  <div className="min-h-screen">
    <Header />
    <BlogPost />
    <Footer />
    <Toaster />
  </div>
);

// Contact page component
const ContactPage = () => (
  <div className="min-h-screen">
    <Header />
    <ContactUsPage />
    <Footer />
    <Toaster />
  </div>
);

// Privacy Policy page component
const PrivacyPage = () => (
  <div className="min-h-screen">
    <Header />
    <PrivacyPolicy />
    <Footer />
    <Toaster />
  </div>
);

// Terms of Service page component
const TermsPage = () => (
  <div className="min-h-screen">
    <Header />
    <TermsOfService />
    <Footer />
    <Toaster />
  </div>
);

// Cookie Policy page component
const CookiePage = () => (
  <div className="min-h-screen">
    <Header />
    <CookiePolicy />
    <Footer />
    <Toaster />
  </div>
);

function App() {
  return (
    <BrowserRouter>
    <Analytics />
      <LanguageProvider>
        <BannerProvider>
          <Routes>
            {/* Redirect root to /ar */}
            <Route path="/" element={<Navigate to="/ar" replace />} />

            {/* Main home page */}
            <Route path="/:lang" element={<MainContent />} />

            {/* Blog post page */}
            <Route path="/:lang/blog/:slug" element={<BlogPage />} />

            {/* Contact page */}
            <Route path="/:lang/contact" element={<ContactPage />} />

            {/* Legal pages */}
            <Route path="/:lang/privacy-policy" element={<PrivacyPage />} />
            <Route path="/:lang/terms-of-service" element={<TermsPage />} />
            <Route path="/:lang/cookie-policy" element={<CookiePage />} />

            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/ar" replace />} />
          </Routes>
        </BannerProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;